import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useAuth } from '../../AuthContext'; 
import CourseDetails from './CourseDetails'; // Import the CourseDetails component
import ntypeImage01 from '../../assets/Frame 29187.png'
import ntypeImage02 from '../../assets/Frame 29156.png'
import ntypeImage03 from '../../assets/Frame 29155.png'
import ntypeImage04 from '../../assets/Frame 29154.png'
import ntypeImage05 from '../../assets/Frame 29188.png'
import configData from '../../configure'; // Import the configData object

import './Admission.css';

const classOptions = [
  { label: "Class 6A", value: "db239250-310f-4a79-b81d-86b3af9f79b4" },
  { label: "Class 6B", value: "e00f1b80-c940-4dc2-a763-678fde977254" },
  { label: "Class 6C", value: "dd24b005-71d8-46c1-bca2-848b4c97738e" },
  { label: "Class 7A", value: "bff12285-2e3f-483e-a717-961ede7dad09" },
  { label: "Class 7B", value: "94d6e73a-6c2d-43ce-9492-bbe93638df77" },
  { label: "Class 7C", value: "ba44d914-6bfa-4268-b86d-8addf4dd73a4" },
];
function Courses() {
  const { axios } = useAuth();
  const [users, setUsers] = useState([]);
  const [selectedClass, setSelectedClass] = useState(classOptions[0].value);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedClassDetails, setSelectedClassDetails] = useState(null);
  const [selectedDay, setSelectedDay] = useState('Monday');
  const [showCourseDetails, setShowCourseDetails] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  // Function to fetch faculty details by ID
  const facultyApiEndpoint = 'http://localhost:8010/organizations/api/users';
  const [facultyName, setFacultyName] = useState('');

  useEffect(() => {
    if (selectedClass) {
      fetchClassDetails(selectedClass);
    }
  }, [selectedClass]);

  async function fetchClassDetails(classId) {
    try {
  
      const response = await axios.get(
        `/organizations/api/classes/${classId}`
      );
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
      console.log('Class API Response:', data);
  
      if (data.classScheduleMap) {
        setSelectedClassDetails(data);
      }
    } catch (error) {
      console.error('Error fetching class details:', error);
    }
  }
  

  useEffect(() => {
    if (selectedClass === '') {
      setFilteredUsers(users);
    } else {
      const filteredData = users.filter((user) => user.classId === selectedClass);
      setFilteredUsers(filteredData);
    }
  }, [selectedClass, users]);

  const handleTableRowClick = (user) => {
    setSelectedUser(user);
    if (user.classId) {
      fetchClassDetails(user.classId);
    }
  };

  const handleNeedBoxClick = (course) => {
    setSelectedCourse(course);
    setShowCourseDetails(true);
  };

  const handleCloseCourseDetails = () => {
    setShowCourseDetails(false);
  };


  console.log('dsdsc')

  async function fetchFacultyDetails(facultyId) {
    console.log(facultyId)
    try {
      const response = await axios.get(`/organizations/api/users/${facultyId}`);

      if (!response.ok) {
      }
      const data = await response.json();

  
      // console.log('Class API Response:', data.userDetails.firstname);
      console.log(data.userDetails.firstname)
      setFacultyName(data.userDetails.firstname);

      return data.userDetails.firstname
    // Extract the faculty name from the response
    // const facultyDetails = data.userDetails;
    // const name = `${facultyDetails.firstname} ${facultyDetails.lastname}`;

    // Set the faculty name in state
    // setFacultyName(name);
  
  
    } catch (error) {
      console.error('Error fetching class details:', error);
    }
  }

  useEffect(() => {
    const name =   fetchFacultyDetails('12')
    console.log(name)



  }, []);
  
  const imageMap = {
    'Maths': ntypeImage01,
    'Hindi': ntypeImage02,
    'English': ntypeImage04,
    'Singing': ntypeImage03,
    'Science': ntypeImage05

  }

  useEffect(() => {
    if (selectedCourse && selectedCourse.facultyId) {
      fetchFacultyDetails(selectedCourse.facultyId);
    }
  }, [selectedCourse]);

  return (
    <div>
      <h3>Courses</h3>
      <div className="select-container">
        <div className="select-item">
          <label>Grade</label>
          <Select
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
          >
          {classOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
      ))}
    </Select>
  </div>
  <div className="select-item">
    <label>Day</label>
    <Select
      value={selectedDay}
      onChange={(e) => setSelectedDay(e.target.value)}
    >
      {selectedClassDetails
        ? Object.keys(selectedClassDetails.classScheduleMap).map((day) => (
            <MenuItem key={day} value={day}>
              {day}
            </MenuItem>
          ))
        : null}
    </Select>
  </div>
      </div>


      <div className="needContainer">
        {selectedDay && selectedClassDetails ? (
          selectedClassDetails.classScheduleMap[selectedDay].map((course) => (
            <div className="needBox" key={course.courseId} onClick={() => handleNeedBoxClick(course)}>
             
              <div className="imgGridNT">
                      <img src={imageMap[course.courseName]} alt="courses" height="118px" />
                    </div>
                    <div className="need-container-volunteer" style={{ color: 'rgb(23, 193, 232)' }}>
                <span className="course-value">{course.courseName}</span>
              </div>
              {/* <div className="course-info">
                <span className="course-label">Faculty Name:</span>
                <span className="course-value">faculty1</span>
              </div>
              <div className="course-info">
                <span className="course-label">Start Time:</span>
                <span className="course-value">{course.startTime}</span>
              </div>
              <div className="course-info">
                <span className="course-label">Duration:</span>
                <span className="course-value">{course.durationMins} mins</span>
              </div> */}
            </div>
          ))
        ) : null}
      </div>

      {showCourseDetails && selectedCourse && (
        <div className="course-details">
          <h3>Course Details</h3>
          <p>Course Name: {selectedCourse.courseName}</p>
          <p>Faculty Name: {facultyName}</p> {/* Display faculty name here */}
          <p>Start Time: {selectedCourse.startTime}</p>
          <p>Duration: {selectedCourse.durationMins} mins</p>
          <button onClick={handleCloseCourseDetails}>Close</button>
        </div>
      )}
    </div>
  );
}

export default Courses;